import axios from 'axios';
import { PROMOTION_TYPE } from '../../constants/payment.constants';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { LISTING_STATE_PUBLISHED } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import { getMaxPrice } from '../SearchPage/SearchPage.duck';

// ================ Action types ================ //

export const FETCH_LISTINGS_REQUEST = 'app/LandingPage/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTINGS_SUCCESS = 'app/LandingPage/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_ERROR = 'app/LandingPage/FETCH_LISTINGS_ERROR';

export const FETCH_VAARPARTNERS_REQUEST = 'app/LandingPage/FETCH_VAARPARTNERS_REQUEST';
export const FETCH_VAARPARTNERS_SUCCESS = 'app/LandingPage/FETCH_VAARPARTNERS_SUCCESS';
export const FETCH_VAARPARTNERS_ERROR = 'app/LandingPage/FETCH_VAARPARTNERS_ERROR';

export const FETCH_BLOGS_REQUEST = 'app/LandingPage/FETCH_BLOGS_REQUEST';
export const FETCH_BLOGS_SUCCESS = 'app/LandingPage/FETCH_BLOGS_SUCCESS';
export const FETCH_BLOGS_ERROR = 'app/LandingPage/FETCH_BLOGS_ERROR';
export const FETCH_TOTAL_LISTINGS_SUCCESS = 'app/LandingPage/FETCH_TOTAL_LISTINGS_REQUEST';

export const FETCH_VAARTIPS_REQUEST = 'app/LandingPage/FETCH_VAARTIPS_REQUEST';
export const FETCH_VAARTIPS_SUCCESS = 'app/LandingPage/FETCH_VAARTIPS_SUCCESS';
export const FETCH_VAARTIPS_ERROR = 'app/LandingPage/FETCH_VAARTIPS_ERROR';

const initialState = {
  listings: null,
  fetchingListingsInProgress: false,
  fetchingListingsError: null,

  vaarpartners: null,
  vaarpartnersInProgress: false,
  vaarpartnersError: null,

  blogs: null,
  blogsInProgress: false,
  blogsError: null,
  pagination: null,

  vaartips: null,
  vaartipsInProgress: false,
  vaartipsError: null,
};

const landingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTINGS_REQUEST:
      return {
        ...state,
        fetchingListingsInProgress: true,
      };
    case FETCH_LISTINGS_SUCCESS:
      return {
        ...state,
        listings: payload.items,
        fetchingListingsInProgress: false,
      };
    case FETCH_TOTAL_LISTINGS_SUCCESS:
      return {
        ...state,
        pagination: payload.pagination,
      };
    case FETCH_LISTINGS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, fetchingListingsInProgress: false, fetchingListingsError: payload };

    case FETCH_VAARPARTNERS_REQUEST:
      return {
        ...state,
        vaarpartnersInProgress: true,
        vaarpartnersError: null,
      };
    case FETCH_VAARPARTNERS_SUCCESS:
      return {
        ...state,
        vaarpartnersInProgress: false,
        vaarpartners: payload,
      };
    case FETCH_VAARPARTNERS_ERROR:
      return {
        ...state,
        vaarpartnersInProgress: false,
        vaarpartnersError: payload,
      };

    case FETCH_VAARTIPS_REQUEST:
      return {
        ...state,
        vaartipsInProgress: true,
        vaartipsError: null,
      };
    case FETCH_VAARTIPS_SUCCESS:
      return {
        ...state,
        vaartipsInProgress: false,
        vaartips: payload,
      };
    case FETCH_VAARTIPS_ERROR:
      return {
        ...state,
        vaartipsInProgress: false,
        vaartipsError: payload,
      };

    case FETCH_BLOGS_REQUEST:
      return {
        ...state,
        blogsInProgress: true,
        blogsError: null,
      };
    case FETCH_BLOGS_SUCCESS:
      return {
        ...state,
        blogsInProgress: false,
        blogs: payload,
      };
    case FETCH_BLOGS_ERROR:
      return {
        ...state,
        blogsInProgress: false,
        blogsError: payload,
      };

    default:
      return state;
  }
};

export default landingPageReducer;

// ================ Action creators ================ //

export const queryListingsRequest = queryParams => ({
  type: FETCH_LISTINGS_REQUEST,
});

export const queryListingsSuccess = data => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: { items: data },
});

export const queryTotalListingsSuccess = data => ({
  type: FETCH_TOTAL_LISTINGS_SUCCESS,
  payload: { pagination: data },
});

export const queryListingsError = e => ({
  type: FETCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchVaarparnetrsRequest = () => ({
  type: FETCH_VAARPARTNERS_REQUEST,
});
export const fetchVaarparnetrsSuccess = vaarpartners => ({
  type: FETCH_VAARPARTNERS_SUCCESS,
  payload: vaarpartners,
});
export const fetchVaarparnetrsError = e => ({
  type: FETCH_VAARPARTNERS_ERROR,
  payload: e,
  error: true,
});

export const fetchVaartipsRequest = () => ({
  type: FETCH_VAARTIPS_REQUEST,
});
export const fetchVaartipsSuccess = vaartips => ({
  type: FETCH_VAARTIPS_SUCCESS,
  payload: vaartips,
});
export const fetchVaartipsError = e => ({
  type: FETCH_VAARTIPS_ERROR,
  payload: e,
  error: true,
});

export const fetchBlogsRequest = () => ({
  type: FETCH_BLOGS_REQUEST,
});
export const fetchBlogsSuccess = blogs => ({
  type: FETCH_BLOGS_SUCCESS,
  payload: blogs,
});
export const fetchBlogsError = e => ({
  type: FETCH_BLOGS_ERROR,
  payload: e,
});

export const queryListings = queryParams => (dispatch, getState, sdk) => {
  dispatch(queryListingsRequest(queryParams));

  const { perPage, ...rest } = queryParams;
  const params = { ...rest, perPage };

  return sdk.listings
    .query(params)
    .then(response => {
      const denormalised = denormalisedResponseEntities(response);
      dispatch(queryListingsSuccess(denormalised));
      return response;
    })
    .catch(e => {
      dispatch(queryListingsError(storableError(e)));
      throw e;
    });
};

export const fetchVaarpartners = () => dispatch => {
  dispatch(fetchVaarparnetrsRequest());

  return axios
    .get(
      'https://www.vaarmarkt.nl/wp-json/wp/v2/vaarpartners?per_page=20&page=1&acf_format=standard'
    )
    .then(async r => {
      dispatch(fetchVaarparnetrsSuccess(r.data));
    })
    .catch(e => {
      console.error(e);
      dispatch(fetchVaarparnetrsError(storableError(e)));
    });
};

export const fetchVaartips = () => dispatch => {
  dispatch(fetchVaartipsRequest());

  return axios
    .get('https://www.vaarmarkt.nl/wp-json/wp/v2/posts?per_page=10&page=1&categories=207')
    .then(async r => {
      dispatch(fetchVaartipsSuccess(r.data));
    })
    .catch(e => {
      console.error(e);
      dispatch(fetchVaartipsError(storableError(e)));
    });
};

export const fetchBlogs = () => dispatch => {
  dispatch(fetchBlogsRequest());

  return axios
    .get('https://www.vaarmarkt.nl/wp-json/wp/v2/posts?per_page=15&page=1')
    .then(async r => {
      dispatch(fetchBlogsSuccess(r.data));
    })
    .catch(e => {
      console.error(e);
      dispatch(fetchBlogsError(storableError(e)));
    });
};

export const queryTotalListings = () => (dispatch, getState, sdk) => {
  return sdk.listings
    .query({ states: LISTING_STATE_PUBLISHED, meta_isPaused: false })
    .then(response => {
      dispatch(queryTotalListingsSuccess(response?.data?.meta));
      return response;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const queryParams = parse(search);

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const promotionPlan = [
    PROMOTION_TYPE.RECURRING.RECOMMENDED,
    PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
  ].join(',');

  return Promise.all([
    dispatch(fetchCurrentUser()),
    dispatch(fetchVaarpartners()),
    dispatch(fetchVaartips()),
    dispatch(fetchBlogs()),
    dispatch(
      queryListings({
        ...queryParams,
        page: 1,
        perPage: 20,
        include: ['images', 'currentStock', 'author'],
        'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        'limit.images': 1,
        meta_promotionPlan: promotionPlan,
        sort: 'meta_order',
      })
    ),
    dispatch(queryTotalListings()),
    dispatch(getMaxPrice()),
  ]);
};
